<template>
  <div class="container">
    <div class="item line_bottom">
      <div class="left">
        <span>退货单号</span>
        <span>{{this.$store.state.orderNum}}</span>
      </div>
      <!-- <span>></span> -->
    </div>
    <!-- <div class="item">
               <div class="left">
                   <span>操作人</span>
                   <span>{{orderNumber}}</span>
               </div>
    </div>-->
    <div class="result">
      <span class="info">补充</span>
      <textarea class="content" placeholder="请输入内容..." v-model="content"></textarea>
    </div>
    <div class="btn" v-if="isOriginHei">
      <span @click="confirm" :class="{'active':change}">确定</span>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/refund.js';
    // import {Toast} from 'mint-ui'
    export default {
        data () {
            return {
                content: '',
                flowId: this.$router.currentRoute.query.flowId,
                isOriginHei: true,
                documentHeight: document.documentElement.clientHeight, // 默认屏幕高度
                isflag: true
            };
        },
        computed: {
            change () {
                if (this.content.trim().length > 0) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        mounted () {
            window.onresize = () => {
                return (() => {
                    if (this.documentHeight > document.documentElement.clientHeight) {
                        this.isOriginHei = false;
                    } else {
                        this.isOriginHei = true;
                    }
                })();
            };
        },
        methods: {
            confirm () {
                if (this.content.trim().length === 0) {
                    this.$Toast({
                        message: '请填写补充内容'
                    })
                } else {
                    if (this.isflag) {
                        api
                            .audit({
                                flowId: this.$store.state.refund.flowId,
                                status: '23',
                                content: this.content
                            })
                            .then(res => {
                                if (res.ret === 0) {
                                    this.$Toast({
                                        message: '操作成功'
                                    })
                                    this.isOriginHei = false;
                                    setTimeout(() => {
                                        this.$router.back();
                                    }, 1500);
                                } else {
                                }
                            });
                        this.isflag = false;
                    }
                }
            }
        }
    };
</script>
<style scoped  lang="less">
.container {
  width: 100%;
  height: 100%;
  padding: 0 15px;
  .item {
    display: flex;
    display: -webkit-flex;
    padding: 22px 0;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    .left {
      span:nth-child(1) {
        display: inline-block;
        width: 100px;
      }
      span {
        font-size: 15px;
        color: #4a4a4a;
      }
      .result_style {
        color: #d4d4d4;
      }
    }
  }
  .result {
    .info {
      display: inline-block;
      padding-top: 23px;
      padding-bottom: 14px;
      font-size: 15px;
      color: #4a4a4a;
    }
    .content {
      width: 100%;
      height: 240px;
      background-color: #f9f9f9;
      border: 0;
      outline: none;
      resize: none;
      padding: 15px 0 0 15px;
      box-sizing: border-box;
      border-radius: 3px;
      font-size: 15px;
      line-height: 21px
    }
  }
  .btn {
    width: 100%;
    height: 50px;
    padding: 0 15px;
    position: fixed;
    left: 0;
    bottom: 15px;
    span {
      width: 100%;
      height: 100%;
      display: inline-block;
      background-color: @base-color;
      opacity: 0.5;
      text-align: center;
      line-height: 50px;
      color: 16px;
      font-size: 16px;
      color: #fff;
      border-radius: 3px;
    }
    .active {
      opacity: 1;
    }
  }
}
</style>
